import { useController, UseControllerProps } from 'react-hook-form'
import PhoneInput from 'react-phone-input-2'
import cl from 'clsx'

import classes from './ContragentModal.module.scss'
import { FormValues, isFieldRequired, ContragentType } from './form/schema'

type PhoneFieldProps = Omit<UseControllerProps<FormValues>, 'name'> & {
    type: ContragentType
    name: 'phone'
    label: string
    roleType?: 'publisher' | 'advertiser' | 'agency' | 'ors'
}

export const PhoneField = ({
    label,
    type,
    roleType,
    ...controllerProps
}: PhoneFieldProps) => {
    const { field, fieldState, formState } = useController(controllerProps)
    const { name } = controllerProps

    const required = isFieldRequired(type, name, roleType)

    return (
        <label
            className={cl(classes.textField, {
                [classes.required]: required,
            })}
        >
            <div className={classes.label}>{label}</div>
            <PhoneInput
                inputClass={cl(
                    'border w-full h-[32px] p-[8px] text-xs rounded-[6px]',
                    fieldState.error ? 'border-red-500' : ''
                )}
                containerClass="w-full"
                specialLabel=""
                placeholder="+XXX XXX XXX XXX"
                disabled={formState.isSubmitting}
                value={field.value}
                onChange={(phone) => {
                    field.onChange(phone.startsWith('+') ? phone : `+${phone}`)
                }}
                onBlur={field.onBlur}
            />
            {fieldState.error?.message && (
                <div className="text-[10px] text-red-500">
                    {fieldState.error.message}
                </div>
            )}
        </label>
    )
}
